const STORAGE_KEY = 'theme:grid-density';

class GridDensityToggle extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this._onClick);
    this._sync(this._density);
  }

  get _density() {
    return localStorage.getItem(STORAGE_KEY) || 'compact';
  }

  _onClick(event) {
    const button = event.target.closest('button[data-density]');

    if (!button) return;

    const density = button.dataset.density;
    localStorage.setItem(STORAGE_KEY, density);
    this._sync(density);
  }

  _sync(density) {
    document.querySelectorAll('grid-density-toggle').forEach((toggle) => {
      toggle.querySelectorAll('button[data-density]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.density === density));
      });
    });

    const section = this.closest('.shopify-section');

    if (!section) return;

    if (density === 'cozy') {
      section.setAttribute('data-grid-density', 'cozy');
    } else {
      section.removeAttribute('data-grid-density');
    }
  }
}

if (!window.customElements.get('grid-density-toggle')) {
  window.customElements.define('grid-density-toggle', GridDensityToggle);
}
